import actionTypes from './actionTypes';

export const fetch = (sid, iid) => ({
  type: actionTypes.FETCH,
  payload: {
    sid,
    iid,
  },
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (shipment) => ({
  type: actionTypes.FETCHED,
  payload: {
    shipment,
  },
});

export const failed = () => ({
  type: actionTypes.FAILED,
});

export const updateDistance = (distance) => ({
  type: actionTypes.UPDATE_DISTANCE,
  payload: {
    distance,
  },
});

export const updateDuration = (duration) => ({
  type: actionTypes.UPDATE_DURATION,
  payload: {
    duration,
  },
});

export const updateStatus = (status) => ({
  type: actionTypes.UPDATE_STATUS,
  payload: {
    status,
  },
});

export const updateLocation = (location) => ({
  type: actionTypes.UPDATE_LOCATION,
  payload: {
    location,
  },
});

export const printWaybill = (waybill) => ({
  type: actionTypes.PRINT_WAYBILL,
  payload: {
    waybill,
  },
});
